import { DeliveryFees } from "modules/financial";

const DeliveryFeesPage = () => {
  return <DeliveryFees />;
};

export default DeliveryFeesPage;
